import { render, staticRenderFns } from "./lexicon.vue?vue&type=template&id=dbc76198&scoped=true&"
import script from "./lexicon.vue?vue&type=script&lang=js&"
export * from "./lexicon.vue?vue&type=script&lang=js&"
import style1 from "./lexicon.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc76198",
  null
  
)

export default component.exports